import { gql } from "@apollo/client";

export const GET_TRAMOS = gql`
query allTramos(
    $where: t_HonorarioProfesionalAjusteFilterInput  
) {
    allTramos(where: $where)
    {
        idHonorarioProfesionalAjuste
        idDelegacion
        descripcion
        idTipoProfesional
        valor
        activo
        fechaExpira
    }
}`;

export const adaptTramo = (tramo) => {
  return {
    id: tramo?.idHonorarioProfesionalAjuste,
    idDelegacion: tramo?.idDelegacion,
    descripcion: tramo?.descripcion,
    idTipoProfesional: tramo?.idTipoProfesional,
    valor: tramo?.valor,
    activo: tramo?.activo,
    fechaExpira: tramo?.fechaExpira
  };
};

const adaptTramosArray = (tramosData) => {
  return structuredClone(tramosData?.allTramos)?.
  map((tramo) => adaptTramo(tramo)) || [];
};

export default adaptTramosArray;

export const adaptTramosParsedArray = (tramosData) => {
  return structuredClone(tramosData)?.
  map((tramo) => adaptTramo(tramo)) || [];
};